import { X, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const MARKETPLACE_POINTS = [
  "Resume databases with thousands of mixed-seniority profiles",
  "\u201CSenior\u201D as a self-declared label on a CV",
  "Any stack, any seniority, little specialization",
  "Extra reseller layers between you and your engineer",
  "High rotation and weak long-term continuity",
];

const NEARCORE_POINTS = [
  "Ten Data & Cloud roles only, with deep domain specialization",
  "7+ years of production experience, verified by senior engineers",
  "US end clients only: same time zone, same working culture, never through resellers",
  "Curated shortlist of ~3 profiles in under five business days",
  "Built for continuity: engineers stay on your team long term",
];

export default function ModelCompare() {
  return (
    <section id="the-model" className="bg-white py-14 sm:py-20" data-testid="the-model-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <div className="text-center">
            <p className="font-cond text-xs font-bold uppercase tracking-[0.28em] text-brand-orange">
              The model
            </p>
            <h2 className="mx-auto mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-brand-teal sm:text-4xl">
              Not a marketplace. A boutique bench of senior specialists.
            </h2>
          </div>
        </Reveal>
        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          <Reveal>
            <div className="h-full rounded-2xl border border-brand-teal/10 bg-brand-mist p-8 sm:p-10">
              <p className="font-cond text-[11px] font-bold uppercase tracking-[0.2em] text-brand-slate">
                Marketplaces &amp; body shops
              </p>
              <ul className="mt-6 space-y-5">
                {MARKETPLACE_POINTS.map((point) => (
                  <li key={point} className="flex items-start gap-4 text-sm leading-relaxed text-brand-slate sm:text-base">
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white shadow-sm">
                      <X size={14} className="text-brand-slate/60" />
                    </span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="h-full rounded-2xl bg-[#03383F] p-8 text-white shadow-2xl shadow-brand-teal/25 sm:p-10" data-testid="model-nearcore-card">
              <p className="font-cond text-[11px] font-bold uppercase tracking-[0.2em] text-brand-orange">
                The nearcore model
              </p>
              <ul className="mt-6 space-y-5">
                {NEARCORE_POINTS.map((point) => (
                  <li key={point} className="flex items-start gap-4 text-sm leading-relaxed text-slate-200 sm:text-base">
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#00555E]">
                      <Check size={14} className="text-brand-orange" />
                    </span>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
